import { generateKeys } from '../utils';
export const localDepositorStatuses = generateKeys({
    pendingRegistration: {
        value: 'pendingRegistration',
        label: 'Pending Registration',
        bsStyle: 'secondary',
    },
    submitted: {
        value: 'submitted',
        label: 'Submitted',
        bsStyle: 'primary',
    },
    approved: {
        value: 'approved',
        label: 'Approved',
        bsStyle: 'success',
    },
    terminated: {
        value: 'terminated',
        label: 'Terminated',
        bsStyle: 'danger',
    },
});
